/* eslint-disable react/destructuring-assignment */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import * as constantMessageData from '../../../../../../SharedModules/Errors/constantMessageData';

import {
  dispatchErrorMessages,
  dispatchNMFinCodes,
} from '../../../store/actions';
import { autoFormateDate } from '../../../../../../SharedModules/utilities/utilities';
import { checkQuarterValidation } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';

export default (props) => {
  const dispatch = useDispatch();
  const { colId } = props.column;
  const { disabled, value, data, setDisabledSaveCancelBtn } = props;
  const nmFinCodesGridList = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmFinCodes
  );
  const maxActivityDt = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.maxActivityDt
  );
  const errorMessages = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.errorMessages
  );
  let rowIndex = 0;
  if (nmFinCodesGridList && nmFinCodesGridList.length > 0) {
    rowIndex = nmFinCodesGridList.findIndex((x) => {
      return x.id === props.data?.id;
    });
  }

  const setErrorMessages = (messages) => {
    dispatch(dispatchErrorMessages(messages));
  };
  // handing on change date event
  const handleOnChangeDateFields = (e, name) => {
    const newObj = [...nmFinCodesGridList];
    setDisabledSaveCancelBtn(false);
    let localErr = errorMessages || [];
    props.node.setDataValue(colId, e.target.value);
    newObj[rowIndex][name] = e.target.value;
    newObj[rowIndex].updateRecord = true;
    if (colId === 'rpcArInterfaceIdVO.nmFinStartQtr') {
      newObj[rowIndex].startQtrErr = false;
      localErr = localErr?.filter((item) => {
        return (
          !item.includes(
            `${constantMessageData.START_QTR_UC}#${props.rowIndex + 1}`
          ) &&
          !item.includes(
            `${constantMessageData.QUARTER_FORMAT_ERROR} in row #${
              props.rowIndex + 1
            }`
          )
        );
      });
    }
    if (colId === 'rpcArInterfaceIdVO.nmFinBudgetRef') {
      newObj[rowIndex].nmFinBudgetRefErr = false;
      localErr = localErr?.filter((item) => {
        return !item.includes(
          `${constantMessageData.BUDGET_REF_REQ}in row #${props.rowIndex + 1}`
        );
      });
    }
    if (colId === 'rpcArInterfaceIdVO.nmFinClass') {
      newObj[rowIndex].nmFinClassErr = false;
      localErr = localErr?.filter((item) => {
        return !item.includes(
          `${constantMessageData.CLASS_FIELD_REQ}in row #${props.rowIndex + 1}`
        );
      });
    }
    setErrorMessages([...new Set(localErr)]);
    dispatch(dispatchNMFinCodes(newObj));
  };

  // call on Blur event filed level
  const handleOnBlurDate = (e) => {
    const newObj = [...nmFinCodesGridList];
    setDisabledSaveCancelBtn(false);
    const localErr = errorMessages || [];
    let inputVal = e.target?.value;
    if (colId === 'rpcArInterfaceIdVO.nmFinStartQtr') {
      inputVal = autoFormateDate(inputVal?.toUpperCase());
      newObj[rowIndex][colId] = inputVal;
      if (inputVal === '' && !data?.isDeleteFlag) {
        newObj[rowIndex].startQtrErr = true;
        localErr.push(
          `${constantMessageData.START_QTR_UC}#${
            props.rowIndex + 1
          } of NM Fin Code tab.`
        );
      }
      if (inputVal && !checkQuarterValidation(inputVal)) {
        newObj[rowIndex].startQtrErr = true;
        localErr.push(
          `${constantMessageData.QUARTER_FORMAT_ERROR} in row #${
            props.rowIndex + 1
          }.`
        );
      }
    } else if (colId === 'rpcArInterfaceIdVO.nmFinBudgetRef') {
      if (inputVal === '' && !data?.isDeleteFlag) {
        newObj[rowIndex].nmFinBudgetRefErr = true;
        localErr.push(
          `${constantMessageData.BUDGET_REF_REQ}in row #${props.rowIndex + 1}.`
        );
      }
    } else if (colId === 'rpcArInterfaceIdVO.nmFinClass') {
      if (inputVal === '' && !data?.isDeleteFlag) {
        newObj[rowIndex].nmFinClassErr = true;
        localErr.push(
          `${constantMessageData.CLASS_FIELD_REQ}in row #${props.rowIndex + 1}.`
        );
      }
    }
    newObj[rowIndex][colId] = inputVal;
    newObj[rowIndex].updateRecord = !data?.newRecord;
    props.node.setDataValue(colId, inputVal);
    setErrorMessages([...new Set(localErr)]);
    dispatch(dispatchNMFinCodes(newObj));
  };

  const fromQtrToDT = (val) => {
    const splitQtr = val?.split('Q');
    return splitQtr[0] == '1'
      ? `01/01/${splitQtr[1]}`
      : splitQtr[0] == '2'
      ? `04/01/${splitQtr[1]}`
      : splitQtr[0] == '3'
      ? `07/01/${splitQtr[1]}`
      : splitQtr[0] == '4'
      ? `10/01/${splitQtr[1]}`
      : '';
  };
  if (colId === 'rpcArInterfaceIdVO.nmFinStartQtr') {
    return (
      <div
        data-testid="system-param-text-box"
        className="fullWidth  text-left td-active-cell "
      >
        <TextField
          id={`systemParamtextFiled_${colId}_${rowIndex}`}
          fullWidth
          placeholder=""
          InputLabelProps={{ shrink: true }}
          className={
            nmFinCodesGridList &&
            nmFinCodesGridList[rowIndex] &&
            nmFinCodesGridList[rowIndex].startQtrErr !== undefined &&
            nmFinCodesGridList[rowIndex].startQtrErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
              : 'frr-display-hidden-label frr-remove-formClt-mt-label'
          }
          style={{ maxWidth: '400px' }}
          disabled={
            disabled ||
            (colId === 'rpcArInterfaceIdVO.nmFinStartQtr' &&
              maxActivityDt &&
              value &&
              new Date(moment(new Date(maxActivityDt)).format('MM/DD/yyyy')) >=
                new Date(fromQtrToDT(value)) &&
              new Date(
                moment(new Date(data.lastUpdateDt)).format('MM/DD/yyyy')
              ) >= new Date(moment(new Date()).format('MM/DD/yyyy'))) ||
            data?.enableFlag
          }
          inputProps={{ maxLength: 6 }}
          value={value || ''}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
        />
      </div>
    );
  }
  if (colId === 'rpcArInterfaceIdVO.nmFinBudgetRef') {
    return (
      <div
        data-testid="system-param-text-box"
        className="fullWidth  text-left td-active-cell "
      >
        <TextField
          id={`systemParamtextFiled_${colId}_${rowIndex}`}
          disabled={disabled || data?.enableFlag}
          fullWidth
          placeholder=""
          className={
            nmFinCodesGridList &&
            nmFinCodesGridList[rowIndex] &&
            nmFinCodesGridList[rowIndex].nmFinBudgetRefErr !== undefined &&
            nmFinCodesGridList[rowIndex].nmFinBudgetRefErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
              : 'frr-display-hidden-label frr-remove-formClt-mt-label'
          }
          InputLabelProps={{ shrink: true }}
          style={{ maxWidth: '400px' }}
          inputProps={{ maxLength: 50 }}
          value={value || ''}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
        />
      </div>
    );
  }
  if (colId === 'rpcArInterfaceIdVO.nmFinClass') {
    return (
      <div
        data-testid="system-param-text-box"
        className="fullWidth  text-left td-active-cell "
      >
        <TextField
          id={`systemParamtextFiled_${colId}_${rowIndex}`}
          disabled={disabled || data?.enableFlag}
          fullWidth
          placeholder=""
          className={
            nmFinCodesGridList &&
            nmFinCodesGridList[rowIndex] &&
            nmFinCodesGridList[rowIndex].nmFinClassErr !== undefined &&
            nmFinCodesGridList[rowIndex].nmFinClassErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
              : 'frr-display-hidden-label frr-remove-formClt-mt-label'
          }
          InputLabelProps={{ shrink: true }}
          style={{ maxWidth: '400px' }}
          inputProps={{ maxLength: 50 }}
          value={value || ''}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
        />
      </div>
    );
  }
};
